function initCollectionTabs() {
  const tabHeading = document.querySelectorAll('.js-tab-heading');
  const tabContentElm = document.querySelectorAll('.collection-tabs__item');
  if (tabHeading) {
    tabHeading.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabHeading.forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');

        tabContentElm.forEach((content) => content.classList.remove('selected'));
        document.querySelector(tab.getAttribute('data-id')).classList.add('selected');
      });
    });
  }
};

initCollectionTabs();

document.addEventListener('shopify:section:load', () => {
  initCollectionTabs()
});
